import React, { useCallback, useEffect, useRef } from "react";
import Button from "../../common/Button";
import UploadFile from "../../common/icons/UploadFile";
import Camera from "../../common/icons/Camera";
import Delete from "../../common/icons/Delete";
import toast from "react-hot-toast";

const UploadPrescription = (props) => {
  const {
    error,
    uploading,
    handleUpload,
    fileName,
    setFileName,
    selectedFile,
    setSelectedFile,
    cameraOn,
    setCameraOn,
    imageData,
    setImageData,
    autoSignature,
  } = props;
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const stopCamera = useCallback(() => {
    if (videoRef?.current && videoRef?.current?.srcObject) {
      const stream = videoRef?.current?.srcObject;

      const tracks = stream?.getTracks();
      tracks?.forEach((track) => track?.stop());

      videoRef.current.srcObject = null;
    }
    setCameraOn(false);

    navigator?.mediaDevices
      ?.getUserMedia({ video: true })
      .then((stream) => {
        const tracks = stream?.getTracks();
        tracks?.forEach((track) => track?.stop());
      })
      .catch((err) => console.error("Error stopping camera:", err));
  }, [setCameraOn]);

  useEffect(() => {
    if (selectedFile) {
      stopCamera();
    }
  }, [selectedFile, stopCamera]);

  const startCamera = async () => {
    try {
      const stream = await navigator?.mediaDevices?.getUserMedia({
        video: { facingMode: "environment" },
      });
      videoRef.current.srcObject = stream;
      setCameraOn(true);
    } catch (error) {
      toast.error(
        "Camera not detected. Please connect an external camera or enable the internal camera. "
      );
      console.error("Error accessing camera:", error);
    }
  };

  const capturePhoto = () => {
    const canvas = canvasRef?.current;
    const video = videoRef?.current;
    const context = canvas?.getContext("2d");

    canvas.width = video?.videoWidth;
    canvas.height = video?.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    const dataUrl = canvas.toDataURL("image/png");
    setImageData(dataUrl); // Preview Image
  };

  const uploadPhoto = async () => {
    if (!imageData) return;

    const blob = await (await fetch(imageData)).blob();

    handleUpload(blob);
    stopCamera();
  };

  const handleDeletePhoto = async () => {
    // const stream = await navigator?.mediaDevices?.getUserMedia({
    // 	video: { facingMode: "environment" },
    // });
    // videoRef.current.srcObject = stream;
    // setCameraOn(true);
    setImageData("");
  };
  const handleFileChange = useCallback(
    (e) => {
      const currentFile = e.target.files[0];
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "application/pdf",
      ];
      const maxSize = 10 * 1024 * 1024; // 10MB

      // Validate file type
      if (!currentFile || !validImageTypes.includes(currentFile.type)) {
        toast.error("Please upload a valid image or PDF file.");
        return;
      }

      // Validate file size
      if (currentFile.size > maxSize) {
        toast.error("File size exceeds 10MB. Please upload a smaller file.");
        return;
      }

      handleUpload(currentFile);
    },
    [handleUpload]
  );
  const handleDelete = () => {
    stopCamera();
    setSelectedFile("");
    setFileName("");
    setImageData("");
    stopCamera();
  };
  if ( autoSignature ) return null
  return (
    <>
      {!selectedFile ? (
        <div className="border border-primary-100 p-4 rounded-[8px] bg-white flex flex-col justify-between h-full">
          { !autoSignature && <div className="w-full">
            <h3 className="text-secondry-600 text-[13px] font-semibold text-center mb-3 uppercase">
              Upload Prescription
            </h3>
            <p className="text-[12px] text-primary-400 text-center mb-3 italic">
              * It's mandatory to upload photo of a signed prescription
            </p>
            {/* <Button
							type="button"
							onClick={() => document.getElementById("photoInput").click()}
							className="flex text-[13px] mb-2 items-center justify-center gap-3 text-white bg-primary-600 hover:bg-primary-200 hover:border-primary-200 focus:border-primary-200 border-[4px] border-primary-600 h-[36px] w-full py-[5px] px-[10px] rounded-full shadow-none outline-none">
							<Camera />
							Take Photo
						</Button> */}
            <div>
              <Button
                type="button"
                onClick={() => (cameraOn ? stopCamera() : startCamera())}
                className="flex text-[13px] mb-2 items-center justify-center gap-2 text-white bg-primary-600 hover:bg-primary-700 focus:border-primary-200 border-[2px] border-primary-600 w-full p-2 rounded-[8px] shadow-none outline-none"
              >
                <Camera width={16} height={16} />
                {cameraOn ? "Stop Camera" : "Take Photo"}
              </Button>
              {!cameraOn && (
                <Button
                  type="button"
                  className="text-[13px] text-white bg-primary-600 hover:bg-primary-700 focus:border-primary-200 border-[2px] border-primary-600 w-full rounded-[8px] shadow-none outline-none"
                >
                  <label className="flex items-center gap-2 justify-center relative p-2 w-full cursor-pointer">
                    <input
                      id="photoInput"
                      type="file"
                      className="opacity-0 absolute left-0 w-full h-full top-0 cursor-pointer"
                      onChange={handleFileChange}
                    />
                    <UploadFile width={16} height={16} />
                    Upload
                  </label>
                </Button>
              )}
              <video ref={videoRef} autoPlay style={{ width: "100%" }} />
              {/* <button onClick={startCamera}>Start Camera</button> */}
              {cameraOn && (
                <>
                  <Button
                    type="button"
                    onClick={() => capturePhoto()}
                    className="text-[13px] text-white bg-primary-600 hover:bg-primary-700 focus:border-primary-200 border-[2px] border-primary-600 w-full mt-2 p-2 rounded-[8px] shadow-none outline-none"
                  >
                    Capture Photo
                  </Button>
                  <canvas ref={canvasRef} style={{ display: "none" }} />
                </>
              )}

              {imageData && (
                <div>
                  {/* <button onClick={uploadPhoto}>Upload Photo</button> */}
                  <div className="border border-primary-100 rounded-[8px] bg-primary-50 my-2 h-[calc(100%_-_110px)] flex items-center relative">
                    <img
                      src={imageData}
                      alt="Captured"
                      style={{ width: "100%" }}
                      className="w-full object-contain"
                    />
                    <button
                      className="bg-primary-700 rounded-full h-[30px] w-[30px] absolute right-[8px] bottom-[8px] flex items-center justify-center p-0.5"
                      onClick={handleDeletePhoto}
                    >
                      <Delete fill="#fff" height={20} width={20} />
                    </button>
                  </div>
                </div>
              )}
            </div>
            {}
            {imageData && (
              <Button
                type="button"
                className="text-[13px] text-white bg-success-600 hover:bg-success-700 focus:border-success-200 border-[2px] border-success-600 w-full rounded-[8px] shadow-none outline-none"
                onClick={uploadPhoto}
              >
                <label className="flex items-center gap-2 justify-center relative p-2 w-full cursor-pointer">
                  <UploadFile width={16} height={16} />
                  Confirm & Upload
                </label>
              </Button>
            )}

            {fileName && (
              <p className="text-sm text-gray-600 mt-2 flex items-center justify-center flex-wrap">
                Selected file: {fileName}
              </p>
            )}
            {uploading && <p>Uploading...</p>}
            {error && <p className="text-red-500">{error}</p>}
          </div>}
        </div>
      ) : (
        <div className="border border-primary-100 p-4 rounded-[8px] bg-white flex flex-col h-full relative">
          <h3 className="text-secondry-600 text-[13px] font-semibold text-center mb-3 uppercase">
            Uploaded Prescription
          </h3>
          <div className="flex-1 border border-primary-100 rounded-[8px] bg-primary-50 flex items-center relative overflow-hidden min-h-[120px]">
            {selectedFile?.endsWith(".pdf") || selectedFile?.endsWith("_pdf") ? (
              <p className="w-full text-center text-primary-700 font-medium text-[14px]">
                {selectedFile.split("/").pop().replace("_", ".")} {/* Display the file name */}
              </p>
            ) : (
              <img src={selectedFile} alt="Uploaded prescription" className="w-full h-full object-contain" />
            )}
            <button
              className="bg-primary-700 rounded-full h-[30px] w-[30px] absolute right-[8px] bottom-[8px] flex items-center justify-center p-0.5"
              onClick={handleDelete}
            >
              <Delete fill="#fff" height={20} width={20} />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(UploadPrescription);
